<!--  -->
<template>
  <div id="typeCanvas">
    <div id="row1" class="rowdiv">
      <div id="row1_leftPan">
        <div id="row1_leftPan_top" class="rowdiv">
          <imageBox
            :typeName="typeName"
            :title="imageTitle[0]"
            :url="imageUrls[0]"
          ></imageBox>
        </div>
        <div id="row1_leftPan_middle" class="rowdiv">
          <div id="row1_leftPan_middle_left">
            <imageBox
              :typeName="typeName"
              :title="imageTitle[1]"
              :url="imageUrls[1]"
            ></imageBox>
          </div>
          <div id="row1_leftPan_middle_right">
            <imageBox
              :typeName="typeName"
              :title="imageTitle[2]"
              :url="imageUrls[2]"
            ></imageBox>
          </div>
        </div>
        <div id="row1_leftPan_bottom" class="rowdiv">
          <imageBox
            :typeName="typeName"
            :title="imageTitle[3]"
            :url="imageUrls[3]"
          ></imageBox>
        </div>
      </div>
      <div id="row1_rightPan">
        <div id="row1_rightPan_top" class="rowdiv">
          <imageBox
            :typeName="typeName"
            :title="imageTitle[4]"
            :url="imageUrls[4]"
          ></imageBox>
        </div>
        <div id="row1_rightPan_bottom" class="rowdiv">
          <imageBox
            :typeName="typeName"
            :title="imageTitle[5]"
            :url="imageUrls[5]"
          ></imageBox>
        </div>
      </div>
    </div>
    <div id="row2" class="rowdiv">
      <div id="row2_leftPan">
        <imageBox
          :typeName="typeName"
          :title="imageTitle[6]"
          :url="imageUrls[6]"
        ></imageBox>
      </div>
      <div id="row2_rightPan">
        <imageBox
          :typeName="typeName"
          :title="imageTitle[7]"
          :url="imageUrls[7]"
        ></imageBox>
      </div>
    </div>
    <div id="row3" class="rowdiv">
      <div id="row3_Pan">
        <imageBox
          :typeName="typeName"
          :title="imageTitle[8]"
          :url="imageUrls[8]"
        ></imageBox>
      </div>
    </div>
  </div>
</template>

<script>
import imageBox from './showStyle/imgBox/imgBox'
export default {
  props: {
    typeName: String
  },
  components: {
    imageBox: imageBox
  },
  data () {
    return {
      imageTitle: [],
      imageUrls: []
    }
  },
  methods: {
    loadTypeImages (typeName, count) {
      const api = '/md/front/news/getItemsByTypeName'
      const params = {
        typeName: typeName,
        num: count
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status !== 200) {
          return
        }
        const resMap = res.data
        this.imageUrls = []
        let str
        let p1, p2
        const myObj = this
        if (resMap != null) {
          const pipilu = resMap
          for (var ite in pipilu) {
            str = pipilu[ite].content
            p1 = str.indexOf('"')
            if (p1 > 0) {
              p1++
              p2 = str.indexOf('"', p1 + 20)
              if (p2 > 0) {
                str = str.substring(p1, p2)
                myObj.imageUrls.push('/' + str)
                myObj.imageTitle.push(pipilu[ite].title)
              }
            }
          }
        } else {
          myObj.carouselImgs = []
        }
      })
    }
  },
  mounted () {
    this.loadTypeImages(this.typeName, 9)
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
#typeCanvas {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.rowdiv {
  width: 100%;
  clear: both;
}

#row1 {
  display: flex;
  flex-direction: row;
}

#row2 {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  height: 400px;
}

#row3 {
  margin-top: 20px;
  height: 350px;
}

#row1_leftPan {
  display: flex;
  flex-direction: column;
  width: 60%;
  padding-right: 20px;
}

#row1_rightPan {
  display: flex;
  flex-direction: column;
  width: 40%;
}
#row1_leftPan_top {
  height: 250px;
  padding-bottom: 20px;
}

#row1_leftPan_middle {
  display: flex;
  flex-direction: row;
  height: 300px;
  padding-bottom: 20px;
}

#row1_leftPan_middle_left {
  width: 60%;
  padding-right: 10px;
}
#row1_leftPan_middle_right {
  width: 40%;
  padding-left: 10px;
}

#row1_leftPan_bottom {
  height: 410px;
}

#row1_rightPan_top {
  height: 50%;
  padding-bottom: 10px;
}

#row1_rightPan_bottom {
  height: 50%;
  padding-top: 10px;
}

#row2_leftPan {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#row2_rightPan {
  width: 60%;
  height: 100%;
  padding-left: 20px;
}

#leftPan_bottom {
  padding-top: 10px;
  width: 100%;
  height: 50%;
  display: flex;

  flex-direction: row;
}

#row3_Pan {
  width: 100%;
  height: 100%;
}
</style>
